import type { AxiosInstance } from "axios";

export type SearchBrandsResponse = {
  brands: BrandSearchResult[];
};

export type BrandSearchResult = {
  id: string;
  name: string;
  description: string | null;
  avatarImageUrl: string | null;
  country: string | null;
  updatedAt: string;
};

function stripHtml(value: string | null): string | null {
  if (!value) {
    return value;
  }

  return value
    .replace(/<[^>]+>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export class BrandsService {
  constructor(private readonly axios: AxiosInstance) {}

  async searchById(brandId: string): Promise<BrandSearchResult | null> {
    const response = await this.axios.get<BrandSearchResult>(
      `/brands/${brandId}`,
    );

    if (!response.data) {
      return null;
    }

    const brand = response.data;

    return {
      ...brand,
      description: stripHtml(brand.description),
    };
  }

  async searchByName(query: string): Promise<BrandSearchResult[]> {
    const response = await this.axios.get<SearchBrandsResponse>(
      "/brands/search",
      {
        params: {
          query: query.trim(),
        },
      },
    );

    return response.data.brands.map((brand) => ({
      ...brand,
      description: stripHtml(brand.description),
    }));
  }
}
